import React from 'react';
import { useLocation } from 'react-router-dom';
import { DASHBOARD_STYLED_CONSTS, Dashboard } from '@components/common';
import { Tabs, useMediaQueryContext } from '@fourthwall/components';
import { WebViewVisibilityDecorator } from '@fourthwall/webview-bridge';
import { SettingsMenuItem } from './SettingsMenuItem';
import * as S from './styled';
export const SettingsTabs = ({ tabs, element }) => {
    const { pathname } = useLocation();
    const media = useMediaQueryContext();
    const direction = media.tablet ? 'vertical' : 'horizontal';
    const mobileTabProps = !media.tablet
        ? {
            variant: 'dimmed',
            size: 'medium',
            weight: 'bold',
            scrollable: true,
            scrollIntoView: true,
            scrollIntoViewOffset: DASHBOARD_STYLED_CONSTS.CONTENT_PADDING_HORIZONTAL,
        }
        : {};
    const findActiveTabIndex = () => {
        for (let i = 0; i < tabs.length; i++) {
            const tab = tabs[i];
            if (tab.path === pathname || pathname.startsWith(`${tab.path}/`)) {
                return i;
            }
            // Check nested items
            if (tab.items) {
                for (const item of tab.items) {
                    if (item.path === pathname || pathname.startsWith(`${item.path}/`)) {
                        return i;
                    }
                }
            }
        }
        return 0;
    };
    const defaultIndex = findActiveTabIndex();
    const transformTabToMenuItem = (tab) => ({
        label: tab.name,
        to: tab.path,
        icon: tab.icon,
        activeIcon: tab.activeIcon,
        tag: tab.tag,
        items: tab.items?.filter((item) => !item.hidden).map(transformTabToMenuItem),
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(WebViewVisibilityDecorator, { on: "webview" },
            React.createElement(S.Container, null, element)),
        React.createElement(WebViewVisibilityDecorator, { on: "web" },
            React.createElement(Tabs, { direction: direction, defaultIndex: defaultIndex },
                React.createElement(Dashboard.Section.ScrollableContent, { hideScrollbar: true, fullWidth: true },
                    React.createElement(S.ListWrapper, null, media.tablet ? (React.createElement(S.TabsListWrapper, { direction: direction }, tabs.map((tab) => {
                        const menuItem = transformTabToMenuItem(tab);
                        return React.createElement(SettingsMenuItem, { key: tab.name, ...menuItem });
                    }))) : (React.createElement(Tabs.List, { direction: direction }, tabs.map(({ name, path }) => (React.createElement(S.Tab, { key: name, name: name, to: path, direction: direction, size: "large", ...mobileTabProps }))))))),
                React.createElement(S.Container, null, element)))));
};
